<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.1579 12.5V13.3333C15.1579 14.25 14.4 15 13.4737 15H1.68421C0.749474 15 0 14.25 0 13.3333V1.66667C0 0.75 0.749474 0 1.68421 0H13.4737C14.4 0 15.1579 0.75 15.1579 1.66667V2.5H7.57895C6.64421 2.5 5.89474 3.25 5.89474 4.16667V10.8333C5.89474 11.75 6.64421 12.5 7.57895 12.5H15.1579ZM7.57812 9.83268C7.57812 10.385 8.02584 10.8327 8.57812 10.8327H14.9992C15.5515 10.8327 15.9992 10.385 15.9992 9.83268V5.16601C15.9992 4.61373 15.5515 4.16602 14.9992 4.16602H8.57812C8.02584 4.16602 7.57812 4.61373 7.57812 5.16602V9.83268ZM9.68359 7.5C9.68359 8.19167 10.2478 8.75 10.9468 8.75C11.6457 8.75 12.2099 8.19167 12.2099 7.5C12.2099 6.80833 11.6457 6.25 10.9468 6.25C10.2478 6.25 9.68359 6.80833 9.68359 7.5Z"
    />
  </svg>
</template>
